export const recentReportscolumns = [
  {
    title: "Date Encoded",
    dataIndex: "dateEncoded",
    key: "dateEncoded",
  },
  {
    title: "Encoder",
    dataIndex: "encoder",
    key: "encoder",
  },
  {
    title: "Activity",
    dataIndex: "activity",
    key: "activity",
  },
  {
    title: "Report Date",
    dataIndex: "reportDate",
    key: "reportDate",
  },
];
